import React from 'react';
import { faCheck, faPen, faTrash, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { Task } from '../../types';

interface TimelineTaskModalProps {
    collectionId: string;
    onClose: () => void;
    onDelete: (taskId: string, collectionId: string) => void;
    onEdit: (task: Task, collectionId: string) => void;
    onToggleComplete: (taskId: string, collectionId: string) => void;
    task: Task;
    timeLabel: string;
}

export const TimelineTaskModal: React.FC<TimelineTaskModalProps> = ({
    collectionId, onClose, onDelete, onEdit, onToggleComplete, task, timeLabel,
}) => {
    const { t } = useTranslation();
    const complete = () => { onToggleComplete(task.id, collectionId); onClose(); };
    const edit = () => { onEdit(task, collectionId); onClose(); };
    const remove = () => { onDelete(task.id, collectionId); onClose(); };
    return (
        <div className="timeline-task-modal-overlay" role="presentation" onClick={onClose}>
            <section className="timeline-task-modal" role="dialog" aria-modal="true" aria-label={task.title}
                onClick={(event) => event.stopPropagation()}>
                <button type="button" className="timeline-task-modal-close" onClick={onClose} aria-label={t('dailyPlanner.cancel')}>
                    <FontAwesomeIcon icon={faXmark} />
                </button>
                <h2>{task.title}</h2>
                <p>{timeLabel}</p>
                <div className="timeline-task-modal-actions">
                    <button type="button" className="timeline-task-modal-complete" onClick={complete}>
                        <FontAwesomeIcon icon={faCheck} /> {t(task.completed ? 'dailyPlanner.markIncomplete' : 'dailyPlanner.markComplete')}
                    </button>
                    <button type="button" onClick={edit}><FontAwesomeIcon icon={faPen} /> {t('dailyPlanner.editTask')}</button>
                    <button type="button" className="is-danger" onClick={remove}><FontAwesomeIcon icon={faTrash} /> {t('dailyPlanner.deleteTask')}</button>
                </div>
            </section>
        </div>
    );
};
